// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { fileArrowCurvedRight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-file-arrow-curved-right': IconFileArrowCurvedRight;
    }
}

/**
 * The icon component for the 'fileArrowCurvedRight' icon
 */
export class IconFileArrowCurvedRight extends Icon {
    public constructor() {
        super(fileArrowCurvedRight16X16);
    }
}

registerIcon('icon-file-arrow-curved-right', IconFileArrowCurvedRight);
export const iconFileArrowCurvedRightTag = 'nimble-icon-file-arrow-curved-right';
